import { useLang } from '../../i18n/LanguageContext'

export default function StepIndicator({ current }) {
  const { t } = useLang()
  const labels = t('onboarding.steps')

  return (
    <div className="steps">
      {labels.map((label, i) => {
        const num = i + 1
        const isActive = num === current
        const isCompleted = num < current
        const cls = [
          'step',
          isActive && 'step--active',
          isCompleted && 'step--completed',
        ].filter(Boolean).join(' ')

        return (
          <div key={num} style={{ display: 'contents' }}>
            {i > 0 && (
              <div className={`step__connector ${isCompleted ? 'step__connector--completed' : ''}`} />
            )}
            <div className={cls}>
              <div className="step__circle">
                {isCompleted ? (
                  <svg width="14" height="14" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                ) : (
                  num
                )}
              </div>
              <span className="step__label">{label}</span>
            </div>
          </div>
        )
      })}
    </div>
  )
}
